import { useField } from "formik";

const InputTextField = ({label, type, placeholder, autoComplete, className, ...props}) => {
	const [field, meta] = useField(props);
	return (
		<div className={`form-floating ${className || ''}`}>
			<input
				type={type}
				className={`form-control ${meta.touched && meta.error ? 'is-invalid' : ''}` }
				id={`field-${props.name}`}
				placeholder={placeholder}
				autoComplete={autoComplete}
				{...field}
				{...props}
				/>
			<label htmlFor={`field-${props.name}`}>{label}</label>
			{meta.touched && meta.error ?
				<small className="message">{meta.error}</small> : null}
		</div>
	)
}

export default InputTextField;
